import apiRoutes from './api.routes';
import ModelService from './model.service';
import api from './api.service';

const GalleryService = new ModelService(apiRoutes.gallery, '/gallery');

GalleryService.getData = params => api.catchError(async () => {
  const { data, headers: { 'x-total-count': count } } = await api.get(`${apiRoutes.gallery}`, params);
  return { data, count: parseInt(count, 10) };
});

GalleryService.saveMany = params => api.catchError(async () => {
  const data = await api.post(`${apiRoutes.gallery}`, params);
  return data;
});

GalleryService.getPage = (params) => {
  const { doc_id, page, token } = params;
  const firstPartToken = token.substr(0, 5);
  const secondPartToken = token.substr(5);
  return `${api.apiUrl}${apiRoutes.gallery}${apiRoutes.slash}${doc_id}${apiRoutes.slash}${page}?token=${secondPartToken}${firstPartToken}`;
};

GalleryService.modelName = 'Gallery';

GalleryService.TYPE_IMAGE = 'image';

GalleryService.getExtList = t => ({
  [GalleryService.TYPE_IMAGE]: t('Image'),
});

export default GalleryService;



// WEBPACK FOOTER //
// ./src/services/gallery.service.js